<template>
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="6.5" cy="6.5" r="4.875" stroke="#AFAFBE" />
    <path
      d="M6.77116 4.0638C6.77116 4.21338 6.6499 4.33464 6.50033 4.33464C6.35075 4.33464 6.22949 4.21338 6.22949 4.0638C6.22949 3.91422 6.35075 3.79297 6.50033 3.79297C6.6499 3.79297 6.77116 3.91422 6.77116 4.0638Z"
      fill="#AFAFBE"
      stroke="#AFAFBE"
      stroke-width="0.7"
    />
    <path d="M6.5 9.20964V5.41797" stroke="#AFAFBE" />
  </svg>
</template>
